/**
 * Trading preferences - plain UI settings, not secrets, so unlike the
 * trading key these are fine to persist in localStorage normally.
 */
const AUTO_RETRY_KEY = "prediction-market-portal.autoRetryStaleNonce";

/**
 * Opt-in: whether a nonce-rejected trade/deposit/withdraw/dispute/claim
 * should be retried once automatically with a freshly reserved nonce.
 * Defaults to OFF - a stale-nonce rejection only happens from a genuine
 * cross-tab/device race (same-page races are already prevented outright
 * by trader-nonce.js's reservation queue), so retrying silently resubmits
 * a wallet-approved action without the user having asked for that
 * specific resubmission. Off by default until the user opts in here.
 */
export function isAutoRetryEnabled() {
  try {
    return localStorage.getItem(AUTO_RETRY_KEY) === "1";
  } catch {
    return false;
  }
}

export function setAutoRetryEnabled(enabled) {
  try {
    localStorage.setItem(AUTO_RETRY_KEY, enabled ? "1" : "0");
  } catch {
    // localStorage unavailable (private mode / disabled) - preference just
    // won't persist across reloads; retry still defaults to off each time.
  }
}
